<mat-card  mat-elevation-z4>

  @if (globserv.kontakt!=undefined && globserv.kontakt.Personen!=undefined) {
    <div class="tabPersonen">
      @if (!isEdit) {
        <div>
          <mat-table #tablePersonen [dataSource]='persDataSource' >
            <ng-container matColumnDef="Anrede">
              <mat-header-cell *matHeaderCellDef>Anrede</mat-header-cell>
              <mat-cell *matCellDef="let element">{{element.PersAnrede}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Name">
              <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
              <mat-cell *matCellDef="let element">{{element.PersName}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Vorname">
              <mat-header-cell *matHeaderCellDef>Vorname</mat-header-cell>
              <mat-cell *matCellDef="let element">{{element.PersVorname}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Telefon">
              <mat-header-cell *matHeaderCellDef>Telefon</mat-header-cell>
              <mat-cell *matCellDef="let element">{{element.PersTelefon}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Mail">
              <mat-header-cell *matHeaderCellDef>Mail</mat-header-cell>
              <mat-cell *matCellDef="let element">{{element.PersMail}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Menu">
              <mat-header-cell *matHeaderCellDef style="min-width:40px;"></mat-header-cell>
              <mat-cell *matCellDef="let element ; let idx = index " style="min-width:40px;">
                <mat-menu #menuPers="matMenu">
                  <button mat-menu-item (click)="persEdit(element, idx)"  ><span>editieren</span></button>
                  <button mat-menu-item (click)="persDelete(element, idx)"><span>löschen</span></button>
                </mat-menu>
                <button mat-icon-button [matMenuTriggerFor]="menuPers" style="margin-left:-20px;" >
                  <mat-icon>more_vert</mat-icon>
                </button>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displColPers"></mat-header-row>
            <mat-row 	*matRowDef="let row; columns: displColPers" style="font-size: 10px">	</mat-row>
          </mat-table>
          <button mat-flat-button	color="primary"(click)="addPers()" style="margin-top: 10px" >Person hinzufügen</button>
        </div>
      }
      @if (isEdit) {
        <div>
          <div class='ContentTab'>
            <div>
              <mat-form-field class="formularTab" style="margin-top: 20px;">
                <mat-label>Anrede</mat-label>
                <input matInput placeholder="Anrede" [(ngModel)]="editPers.PersAnrede"  name="Anrede" list="salutationList">
                <datalist id="salutationList">
                  @for (s of globserv.salutation; track s) {
                    <option >{{s.name}}</option>
                  }
                </datalist>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="formularTab" style="margin-top: 20px;">
                <mat-label>Name</mat-label>
                <input matInput placeholder="Name" [(ngModel)]="editPers.PersName"  name="Name">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="formularTab" style="margin-top: 20px;">
                <mat-label>Vorname</mat-label>
                <input matInput placeholder="Vorname" [(ngModel)]="editPers.PersVorname"  name="Vorname">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="formularTab" style="margin-top: 20px;">
                <mat-label>Telefon</mat-label>
                <input matInput placeholder="Telefon" [(ngModel)]="editPers.PersTelefon"  name="Telefon">
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="formularTab" style="margin-top: 20px;">
                <mat-label>E-Mail</mat-label>
                <input matInput placeholder="Mail" [(ngModel)]="editPers.PersMail"  name="Mail">
              </mat-form-field>
            </div>
          </div>
          <div  style="text-align:center;">
            <button mat-flat-button	color="primary"(click)="resetEdit()" >abbrechen</button>
            &nbsp;
            <button mat-flat-button [disabled]="editPersChanged()" color="primary" (click)="savePers()" style="margin-left: 30px;" >speichern</button>
          </div>
        </div>
      }
    </div>
  }
</mat-card>
